import React from 'react';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import type { ModalProps } from 'react-bootstrap/Modal';
import type { Variant } from 'react-bootstrap/types';

import { useTranslation } from '../../common/hooks/useTranslation';

interface AlertModalProps extends ModalProps {
  variant?: Variant;
  buttonText?: string;
  buttonVariant?: Variant;
}

export default ({
  variant,
  buttonText,
  buttonVariant,
  ...props
}: AlertModalProps) => {
  const btnVariant = buttonVariant || (variant && 'outline-' + variant);
  const { t, tk } = useTranslation('menuLng');
  return (
    <Modal
      {...props}
      centered={true}
      backdrop="static"
      backdropClassName="modal-on-modal-backdrop"
      className="modal-on-modal"
    >
      <Modal.Body className="p-0">
        <Alert variant={variant} className="m-0">
          <Alert.Heading>{props.children}</Alert.Heading>
          {props.onHide && (
            <>
              <div className="d-flex justify-content-end">
                <Button onClick={props.onHide} variant={btnVariant}>
                  {buttonText || t(tk.button.close)}
                </Button>
              </div>
            </>
          )}
        </Alert>
      </Modal.Body>
    </Modal>
  );
};
